/* unplugin-vue-components disabled */import { render } from "./SummaryItem.vue?vue&type=template&id=6b82ce35&scoped=true&ts=true"
import script from "./SummaryItem.vue?vue&type=script&lang=ts"
export * from "./SummaryItem.vue?vue&type=script&lang=ts"

import "./SummaryItem.vue?vue&type=style&index=0&id=6b82ce35&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b82ce35"]])

export default __exports__